'use once'

module.exports = function once(fn, scope){

    var called
    var result

    return function(){
        if (called){
            return result
        }

        called = true

        return result = fn.apply(scope || this, arguments)
    }
}


//////////////////
// WEBPACK FOOTER
// ../~/drag-helper/utils/once.js
// module id = 2344
// module chunks = 2